import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Fragment } from 'react';
import styled from 'styled-components';
import withTheme from '../theme/withTheme';
import DateUtils from '../utils/date';
import prepareProps from '../utils/prop-types';
import TextInput from '../TextInput';
import CalendarIcon from '../Icons/Calendar';
import DatePicker from '../DatePicker';
import { defaultProps, propTypes } from './propTypes';
var utils = new DateUtils();
var Calendar = styled(CalendarIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return _extends({}, theme.input.date.icon);
});
var formatDate = function formatDate(date) {
  var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dd/MM/yyyy';
  return utils.format(date, dateFormat);
};
var handleDate = function handleDate() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return date && utils.isValid(date) ? formatDate(date) : '';
};
var isValidDate = function isValidDate() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return date && utils.isValid(date);
};
var isWithinRange = function isWithinRange(date, minDate, maxDate) {
  return isValidDate(date) && !utils.isBefore(date, minDate) && !utils.isAfter(date, maxDate);
};

// TODO: update this code onde date-fns is ready for parsing dd/mm/yyyy dates
var parseDate = function parseDate() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var _split = (date || '').split('/'),
    _split2 = _slicedToArray(_split, 3),
    day = _split2[0],
    month = _split2[1],
    year = _split2[2];
  var parsedDate = utils.parse("".concat(day, "/").concat(month, "/").concat(year && (year.length === 2 || year.length === 4) ? year : undefined));
  return parsedDate;
};
var DateInput = /*#__PURE__*/function (_React$PureComponent) {
  function DateInput(props) {
    var _this;
    _classCallCheck(this, DateInput);
    _this = _callSuper(this, DateInput, [props]);
    _this.state = {
      isModalOpen: false
    };
    _this.onBlurHandler = _this.onBlurHandler.bind(_this);
    _this.getValidationProps = _this.getValidationProps.bind(_this);
    _this.getCustomEventProps = _this.getCustomEventProps.bind(_this);
    _this.toggleModalHandler = _this.toggleModalHandler.bind(_this);
    _this.datePickerChangeHandler = _this.datePickerChangeHandler.bind(_this);
    _this.onInputChangeHandler = _this.onInputChangeHandler.bind(_this);
    return _this;
  }
  _inherits(DateInput, _React$PureComponent);
  return _createClass(DateInput, [{
    key: "onInputChangeHandler",
    value: function onInputChangeHandler(_ref2) {
      var target = _ref2.target;
      var _this$props = this.props,
        onChange = _this$props.onChange,
        maxDate = _this$props.maxDate,
        minDate = _this$props.minDate;
      var newDate = parseDate(target.value);
      if (isValidDate(newDate) && isWithinRange(newDate, minDate, maxDate) && onChange) {
        onChange(newDate);
      }
    }
  }, {
    key: "onBlurHandler",
    value: function onBlurHandler(ev) {
      var _this$props2 = this.props,
        onChange = _this$props2.onChange,
        onBlur = _this$props2.onBlur;
      var event = _extends({}, ev);
      var inputValue = event.target.value;
      var parsedDate = parseDate(inputValue);
      event.target = _extends({}, ev.target, this.getCustomEventProps(inputValue));
      if (onChange) onChange(parsedDate);
      if (onBlur) onBlur(event);
    }
  }, {
    key: "getCustomEventProps",
    value: function getCustomEventProps(inputDate) {
      var _this$props3 = this.props,
        minDate = _this$props3.minDate,
        maxDate = _this$props3.maxDate;
      var date = parseDate(inputDate);
      return {
        isDateValid: isValidDate(date),
        isRangeValid: isWithinRange(date, minDate, maxDate),
        dateValue: date,
        value: inputDate
      };
    }
  }, {
    key: "getValidationProps",
    value: function getValidationProps(date) {
      var _this$props4 = this.props,
        minDate = _this$props4.minDate,
        maxDate = _this$props4.maxDate,
        invalidMinDateMessage = _this$props4.invalidMinDateMessage,
        invalidMaxDateMessage = _this$props4.invalidMaxDateMessage,
        invalidDateMessage = _this$props4.invalidDateMessage;
      var props = {
        errorMessage: '',
        validationStatus: 'default'
      };
      if (date) {
        var isDateValid = isValidDate(date);
        props.errorMessage = '';
        props.validationStatus = isDateValid && isWithinRange(date, minDate, maxDate) ? 'default' : 'error';
        if (!isDateValid) props.errorMessage = invalidDateMessage;
        if (isDateValid && utils.isBefore(date, minDate)) props.errorMessage = invalidMinDateMessage;
        if (isDateValid && utils.isAfter(date, maxDate)) props.errorMessage = invalidMaxDateMessage;
      }
      return props;
    }
  }, {
    key: "toggleModalHandler",
    value: function toggleModalHandler() {
      var isModalOpen = this.state.isModalOpen;
      var _this$props5 = this.props,
        disabled = _this$props5.disabled,
        onToggleModalHandler = _this$props5.onToggleModalHandler;
      if (disabled) return;
      this.setState({
        isModalOpen: !isModalOpen
      });
      if (onToggleModalHandler) onToggleModalHandler();
    }
  }, {
    key: "datePickerChangeHandler",
    value: function datePickerChangeHandler(date) {
      var onChange = this.props.onChange;
      this.toggleModalHandler();
      if (onChange) onChange(date);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var isModalOpen = this.state.isModalOpen;
      var _this$props6 = this.props,
        autoValidate = _this$props6.autoValidate,
        errorMessageProp = _this$props6.errorMessage,
        validationStatusProp = _this$props6.validationStatus,
        minDate = _this$props6.minDate,
        maxDate = _this$props6.maxDate,
        theme = _this$props6.theme,
        value = _this$props6.value,
        placeholder = _this$props6.placeholder,
        disabled = _this$props6.disabled;
      var props = prepareProps(propTypes, this.props);
      var inputDate = handleDate(value);
      var validations = this.getValidationProps(value);
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(TextInput, _extends({}, props, {
        disabled: disabled,
        placeholder: placeholder || 'DD/MM/AAAA',
        icon: function icon(calendarProps) {
          return /*#__PURE__*/React.createElement(Calendar, _extends({}, calendarProps, {
            theme: theme,
            onClick: _this2.toggleModalHandler
          }));
        },
        onChange: this.onInputChangeHandler,
        onBlur: this.onBlurHandler,
        value: inputDate,
        options: {
          numericOnly: true,
          blocks: [2, 2, 4],
          delimiter: '/',
          delimiterLazyShow: true
        },
        errorMessage: autoValidate ? validations.errorMessage : errorMessageProp,
        variant: autoValidate ? validations.validationStatus : validationStatusProp
      })), /*#__PURE__*/React.createElement(DatePicker, {
        theme: theme,
        value: value,
        isOpen: isModalOpen,
        minDate: minDate,
        maxDate: maxDate,
        onChange: this.datePickerChangeHandler,
        onClose: this.toggleModalHandler
      }));
    }
  }]);
}(React.PureComponent);
DateInput.defaultProps = defaultProps;
process.env.NODE_ENV !== "production" ? DateInput.propTypes = propTypes : void 0;
export default withTheme(DateInput);